
import { Grid, Image, AutoCenter, Dialog, Selector, Toast, Card, Input } from 'antd-mobile';
import Icon from '../../../icon';
import API_ROUTES from '../../../api';
import axios from 'axios';
import httpClient from '../../../shared/api/httpClient';
import { useCallback, useEffect, useState } from 'react';
import GetSinglePersonFire from '../../ApplicateOne/getSInglePersonFire';
import '../../ApplicateOne/captainCardExtras.css';
import {
    CAPTAIN_WORKFLOW_STAGE,
    canEditMemberAtCaptainStage,
    getCaptainWorkflow
} from '../../../features/match/model/captainWorkflow';
import { getPendingMemberTeamName, getReadyTeamName } from '../../../features/match/model/readyTeamName';

const GameReadyStepOne = ({ gameDetail,
    memberListInfo,
    memberInfo,
    getUserListInfo,
    defaultImage,
    getGameDetail,
    pendingOnly = false
}) => {

    const [joinButtonLoading, setJoinButtonLoading] = useState(false)

    const redCaptian = memberListInfo?.find(item => item.id === gameDetail.redCaptainId)
    const greenCaptain = memberListInfo?.find(item => item.id === gameDetail.greenCaptainId)
    const captainWorkflow = getCaptainWorkflow(gameDetail)
    const [displayList, setDisplayList] = useState([]);
    const [teamNameDraft, setTeamNameDraft] = useState({ green: '', red: '' });
    // 命名阶段按固定队长显示简称，颜色与各自队伍的当前队服色对应。
    const namingTeams = [
        { key: 'green', captainName: greenCaptain?.name || gameDetail?.greenCaptain?.name, color: gameDetail?.greenColor || 'green', fallback: 'A队' },
        { key: 'red', captainName: redCaptian?.name || gameDetail?.redCaptain?.name, color: gameDetail?.redColor || 'red', fallback: 'B队' }
    ];

    // 比赛详情更新时同步已保存队名，命名阶段的输入由主队队长一次提交。
    useEffect(() => {
        setTeamNameDraft({
            green: gameDetail?.greenName || '',
            red: gameDetail?.redName || ''
        });
    }, [gameDetail?.id, gameDetail?.greenName, gameDetail?.redName]);

    // 管理员可代主队队长完成命名，队长只操作自己负责的阶段。
    const canNameTeams = memberInfo?.admin === 1
        || String(memberInfo?.id) === String(gameDetail?.greenCaptainId);

    const saveTeamNames = async () => {
        const greenName = teamNameDraft.green.trim();
        const redName = teamNameDraft.red.trim();
        if (!greenName || !redName) {
            Toast.show({ icon: 'fail', content: '请填写两个队伍名称' });
            return;
        }
        if (greenName === redName) {
            Toast.show({ icon: 'fail', content: '两个队伍名称不能相同' });
            return;
        }
        if (greenName.length > 20 || redName.length > 20) {
            Toast.show({ icon: 'fail', content: '队名最多填写20个字' });
            return;
        }
        setJoinButtonLoading(true);
        try {
            const response = await httpClient.post(API_ROUTES.game_teamNames, {
                gameId: gameDetail.id,
                greenName,
                redName
            });
            if (response.data?.code !== 200) {
                Toast.show({ icon: 'fail', content: response.data?.msg || '保存队名失败' });
                return;
            }
            Toast.show({ icon: 'success', content: '队名已保存，接下来调整队伍成员' });
            getGameDetail();
        } catch (error) {
            Toast.show({ icon: 'fail', content: error?.response?.data?.msg || '保存队名失败，请重试' });
        } finally {
            setJoinButtonLoading(false);
        }
    };


    const ROLE_COLORS = {
        1: { color: '#f59e0b', bg: 'rgba(245, 158, 11, 0.15)', border: '1px solid rgba(245, 158, 11, 0.3)', text: '门将' },     // Amber
        2: { color: '#3b82f6', bg: 'rgba(59, 130, 246, 0.15)', border: '1px solid rgba(59, 130, 246, 0.3)', text: '边后卫' },   // Blue
        3: { color: '#10b981', bg: 'rgba(16, 185, 129, 0.15)', border: '1px solid rgba(16, 185, 129, 0.3)', text: '中后卫' },   // Emerald
        4: { color: '#6366f1', bg: 'rgba(99, 102, 241, 0.15)', border: '1px solid rgba(99, 102, 241, 0.3)', text: '后腰' },     // Indigo
        5: { color: '#8b5cf6', bg: 'rgba(139, 92, 246, 0.15)', border: '1px solid rgba(139, 92, 246, 0.3)', text: '边前卫' },   // Violet
        6: { color: '#ec4899', bg: 'rgba(236, 72, 153, 0.15)', border: '1px solid rgba(236, 72, 153, 0.3)', text: '前腰' },     // Pink
        7: { color: '#ef4444', bg: 'rgba(239, 68, 68, 0.15)', border: '1px solid rgba(239, 68, 68, 0.3)', text: '前锋' },       // Red
        12: { color: '#94a3b8', bg: 'rgba(148, 163, 184, 0.15)', border: '1px solid rgba(148, 163, 184, 0.3)', text: '待选队伍' }, // Slate
    };

    const POSITION_OPTIONS = [
        { label: '门将', value: 1 },
        { label: '边后卫', value: 2 },
        { label: '中后卫', value: 3 },
        { label: '后腰', value: 4 },
        { label: '边前卫', value: 5 },
        { label: '前腰', value: 6 },
        { label: '前锋', value: 7 },
    ];

    // Team naming logic synchronized across ApplicateTwo
    const getTeamName = (teamIndex) => {
        return getReadyTeamName(gameDetail, teamIndex);
    }


    const getFireDetailInfo = useCallback(() => {
        const showMembers = memberListInfo
            ?.filter((item) => null !== item.gameType && item.gameType <= 7)
            ?.map((item) => item.id)
            ?.join(',');

        if (!showMembers) {
            setDisplayList([]);
            return;
        }


        Toast.show({ icon: 'loading', content: '加载中...' });

        axios
            .get(API_ROUTES.game_member_fail_info, {
                params: { memberId: showMembers }
            })
            .then((res) => {
                const data = res.data.data || {};
                setDisplayList(data);
            })
            .catch(() => {
                Toast.show({
                    icon: 'fail',
                    content: '查询失败，请联系管理员'
                });
                setDisplayList([]);
            })
            .finally(() => Toast.clear());
    }, [memberListInfo]);

    useEffect(() => {
        if (memberListInfo && memberListInfo.length > 0) {
            getFireDetailInfo();
        }
    }, [getFireDetailInfo, memberListInfo]);


    const getPendingMembers = () => memberListInfo?.filter(item => item.gameType === 0 && item.gameTeam === null) || [];

    const renderPendingTitle = () => {
        const pendingCount = getPendingMembers().length;
        if (pendingCount <= 0) return null;
        return (
            <div className="waiting-team-title">
                <span className="waiting-team-title-mark"></span>
                <span>待选队队员</span>
                <em>{pendingCount}人</em>
            </div>
        );
    };

    const canOperatePendingMember = (user) => {
        if (!user || user.gameTeam !== null) return false;
        // 命名尚未完成时先锁定调阵动作，防止跳过新的第一步。
        if (captainWorkflow.stage === CAPTAIN_WORKFLOW_STAGE.TEAM_NAMING) return false;
        if (memberInfo?.admin === 1) return true;
        if (memberInfo?.id != null && String(memberInfo.id) === String(user.id)) return true;
        // 分队阶段仅主队队长调整成员；客队队长此时只等待选队。
        if (captainWorkflow.stage === CAPTAIN_WORKFLOW_STAGE.GREEN_ADJUSTMENT
            && memberInfo?.id === greenCaptain?.id) return true;
        return false;
    };

    const getUserRoleInfo = (type, team, flag) => {
        if (!(gameDetail && Array.isArray(memberListInfo))) return null;

        // 过滤成员数据（保持原有逻辑）
        let currentUser = memberListInfo?.filter(user =>
            user.gameRole === type
            && user.gameTeam === team
            && user.id !== redCaptian?.id
            && user.id !== greenCaptain?.id
        );

        if (flag > 0) {
            currentUser = memberListInfo?.filter(item => item.gameType === 0 && item.gameTeam === null);
        }


        // 不败火焰（头部悬浮）
        const renderFireHeader = (user) => (
            <div className="card-fire-header">
                <GetSinglePersonFire
                    records={displayList[user.id]}
                    count={3}
                    trendType="unbeaten"
                />
            </div>
        );

        // 不胜火焰（底部悬浮）
        const renderFireFooter = (user) => (
            <div className="card-fire-footer">
                <GetSinglePersonFire
                    records={displayList[user.id]}
                    count={3}
                    trendType="winless"
                />
            </div>
        );


        // 采用高级玻璃感卡片样式
        return currentUser.map((user) => (
            <Grid.Item key={user.id}>
                <div
                    className="mini-player-item"
                    style={{
                        position: 'relative',
                        overflow: 'visible',
                        cursor: 'pointer',
                        margin: '5px 0px',
                    }}
                    onClick={() => {
                        const changeAllPosition = () => {
                            const isGreenTeam = user.gameTeam === 1;
                            // 队长固定归属，调换队员只按当前 A/B 分组说明，不展示正式队名和队服色。
                            const sourceTeamName = isGreenTeam ? 'A队' : 'B队';
                            const targetTeamName = isGreenTeam ? 'B队' : 'A队';

                            Dialog.confirm({
                                className: 'team-transfer-dialog',
                                title: (
                                    <div className="premium-dialog-header">
                                        <span className="premium-dialog-title-text">调整队伍</span>
                                    </div>
                                ),
                                content: (
                                    <div className="team-transfer-content">
                                        <div className="team-transfer-player">
                                            <img src={defaultImage(user)} alt={user.name} />
                                            <div>
                                                <strong>{user.name}</strong>
                                                <span>调整分队成员</span>
                                            </div>
                                        </div>
                                        <div className="team-transfer-hint">
                                            确认将 {user.name} 从 {sourceTeamName} 调换至 {targetTeamName}？
                                        </div>
                                    </div>
                                ),
                                onConfirm: () => {
                                    Toast.show({ icon: 'loading' });
                                    const data = {
                                        // 点击哪支队伍的球员，就把该球员提交到对应的调整列表。
                                        greenMembers: isGreenTeam ? String(user.id) : '',
                                        redMembers: isGreenTeam ? '' : String(user.id),
                                        gameId: gameDetail.id,
                                    };
                                    // 调队请求走统一认证客户端，旧登录信息也会先自动换取长期凭证。
                                    httpClient.post(API_ROUTES.game_switchPosition, data)
                                        .then(function (response) {
                                            if (response.data?.code !== 200) {
                                                Toast.show({ icon: 'fail', content: response.data?.msg || '调换失败，请重试' });
                                                return;
                                            }
                                            Toast.show({
                                                icon: 'success',
                                                content: '修改成功',
                                                afterClose: () => {
                                                    getUserListInfo();
                                                }
                                            });
                                        })
                                        .catch(function (error) {
                                            Toast.show({
                                                icon: 'fail',
                                                content: error?.response?.data?.msg || '调换失败，请重试'
                                            });
                                        })
                                }
                            });
                        }

                        const changeMemberPosition = () => {
                            let selectTeam = []
                            let selectPosition = user.gameRole && user.gameRole !== 12 ? [user.gameRole] : []
                            // 待选队员本人只选择队伍；队长代分队时仍需指定位置，管理员可按需调整。
                            const isSelfChoosing = memberInfo?.admin !== 1
                                && memberInfo?.id != null && String(memberInfo.id) === String(user.id);
                            const positionRequired = !isSelfChoosing && memberInfo?.admin !== 1;
                            Dialog.confirm({
                                className: 'waiting-team-dialog',
                                title: (
                                    <div className="waiting-team-dialog-title">
                                        <span>加入阵容</span>
                                        <em>{isSelfChoosing ? '选择想加入的队伍' : '选择队伍与位置'}</em>
                                    </div>
                                ),
                                content: (
                                    <div className="waiting-team-dialog-body">
                                        <div className="waiting-team-player">
                                            <img src={defaultImage(user)} alt={user.name} />
                                            <div>
                                                <strong>{user.name}</strong>
                                                <span>{isSelfChoosing ? '选择想加入的队伍' : '选择队伍和场上位置'}</span>
                                            </div>
                                        </div>
                                        <div className="waiting-team-section-title">选择所属阵容</div>
                                        {/* 客队队长选队前使用 A/B 代号，选队后显示实际队名。 */}
                                        <Selector
                                            className="waiting-team-selector waiting-team-selector--team"
                                            options={[
                                                { label: getPendingMemberTeamName(gameDetail, 1), value: 1 },
                                                { label: getPendingMemberTeamName(gameDetail, 2), value: 2 },
                                            ]}
                                            columns={2}
                                            onChange={a => (selectTeam = a)}
                                        />
                                        {!isSelfChoosing && <>
                                            <div className="waiting-team-section-title">选择场上位置</div>
                                            <Selector
                                                className="waiting-team-selector waiting-team-selector--role"
                                                options={POSITION_OPTIONS}
                                                columns={3}
                                                defaultValue={selectPosition}
                                                onChange={a => (selectPosition = a)}
                                            />
                                        </>}
                                    </div>
                                ),
                                onConfirm: () => {
                                    if (!selectTeam?.length) {
                                        Toast.show({ icon: 'fail', content: '请选择队伍' })
                                        return Promise.reject();
                                    }
                                    if (positionRequired && !selectPosition?.length) {
                                        Toast.show({ icon: 'fail', content: '请选择位置' })
                                        return Promise.reject();
                                    }
                                    const data = {
                                        team: selectTeam[0],
                                        position: isSelfChoosing ? null : (selectPosition[0] || null),
                                        gameId: gameDetail.id,
                                        userId: user.id
                                    };
                                    httpClient.post(API_ROUTES.game_changePosition, data)
                                        .then((response) => {
                                            if (response.data?.code !== 200) {
                                                Toast.show({ icon: 'fail', content: response.data?.msg || '修改失败' });
                                                return;
                                            }
                                            Toast.show({
                                                icon: 'success',
                                                content: '修改成功',
                                                duration: 2
                                            })
                                            getUserListInfo()
                                        })
                                        .catch(() => {
                                            Toast.show({
                                                icon: 'fail',
                                                content: '修改失败',
                                            })
                                        })
                                        .finally(() => {
                                            Toast.clear()
                                        });
                                }
                            });
                        }

                        const isPendingMember = user?.gameType === 0 && user?.gameTeam === null
                        if (isPendingMember) {
                            if (canOperatePendingMember(user)) {
                                changeMemberPosition()
                            }
                            return;
                        }

                        if (canEditMemberAtCaptainStage(captainWorkflow, memberInfo, greenCaptain?.id)) {
                            if (user?.gameTeam > 0) {
                                changeAllPosition()
                            } else {
                                changeMemberPosition()
                            }
                        }

                    }}
                >
                    <div className="mini-avatar-wrapper">
                        <img
                            src={defaultImage(user)}
                            className="mini-avatar"
                            alt={user.name}
                            style={{
                                border: captainWorkflow.showLineupSetup && user.gameTeam != null ?
                                        (user.gameTeam === 1 ? `2px solid ${gameDetail.greenColor}` : `2px solid ${gameDetail.redColor}`) : 'none',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)'
                            }}
                        />
                    </div>

                    <div style={{
                        marginTop: '4px',
                        padding: '1px 6px',
                        borderRadius: '6px',
                        fontSize: '12px',
                        background: `${ROLE_COLORS[user.gameRole]?.bg || 'rgba(255,255,255,0.1)'}`,
                        color: ROLE_COLORS[user.gameRole]?.color || '#fff',
                        border: `${ROLE_COLORS[user.gameRole]?.border || '1px solid transparent'}`,
                        fontWeight: 600,
                        letterSpacing: '0.5px',
                        whiteSpace: 'nowrap',
                        display: 'inline-block',
                        lineHeight: '1.4'
                    }}>
                        {ROLE_COLORS[user.gameRole]?.text}
                    </div>

                    <div className="mini-player-name" style={{ marginTop: '2px' }}>
                        {user.name}
                    </div>

                    {renderFireHeader(user)}
                    {renderFireFooter(user)}
                </div>
            </Grid.Item>
        ));
    };


    const getCaptainImage = (captainId, color) => {
        const captainImageList = memberListInfo.filter(item => item.id === captainId)[0]?.memberImageList

        if (color === "red") {
            return captainImageList?.filter(item => item.type === 2)[0]?.image + Icon.ImageFooter
        } else if (color === "green") {
            return captainImageList?.filter(item => item.type === 1)[0]?.image + Icon.ImageFooter
        } else if (color === "#CCCCFF") {
            return captainImageList?.filter(item => item.type === 5)[0]?.image + Icon.ImageFooter
        } else {
            return Icon.KEPENG_LOGO
        }
    }



    const renderCaptainCard = (captain, teamColor, teamName, isRed, confirmStatus) => {
        const teamClass = isRed ? 'team-red' : 'team-green';
        const statusText = confirmStatus > 0 ? "已就绪" : "待确认";
        const statusColor = confirmStatus > 0 ? "#22d3ee" : "#cbd5e1"; // Cyan (Ready) vs Slate (Pending)
        const statusBg = confirmStatus > 0 ? "rgba(34, 211, 238, 0.15)" : "rgba(148, 163, 184, 0.1)";
        const statusBorder = confirmStatus > 0 ? "rgba(34, 211, 238, 0.5)" : "rgba(148, 163, 184, 0.3)";
        const statusShadow = confirmStatus > 0 ? "0 0 8px rgba(34, 211, 238, 0.4)" : "none";
        const statusIcon = confirmStatus > 0 ? "✨" : "⏳";

        return (
            <div className={`command-captain-card ${teamClass}`} style={{ 
                '--team-color': teamColor, 
                width: '100%',
                border: `2px solid var(--team-color, #165DFF)`,
                boxShadow: (isRed ? '0 4px 16px rgba(239, 68, 68, 0.15)' : '0 4px 16px rgba(16, 185, 129, 0.15)')
            }}>
                <div className="team-banner-aura"></div>
                <div className="command-card-content">
                    <div className="captain-avatar-core">
                        <div className="avatar-pulse-ring"></div>
                        <Image
                            src={getCaptainImage(captain?.id, teamColor)}
                            className="command-avatar-img"
                            fit='cover'
                            style={{ 
                                borderRadius: '50%',
                                border: `2px solid var(--team-color, #165DFF)`,
                                boxShadow: `0 4px 12px color-mix(in srgb, var(--team-color, #165DFF), transparent 70%)`
                            }}
                        />
                        {teamColor === "#CCCCFF" && <div className="command-crown">👑</div>}
                    </div>

                    <div className="command-info">
                        <div className="command-name">{captain?.name || '待定'}</div>
                        <div className="team-identity-label">
                            <span className="team-indicator-dot"></span>
                            {teamName} 统帅
                        </div>
                        <div style={{
                            marginTop: '8px',
                            fontSize: '11px',
                            fontWeight: 800,
                            padding: '4px 10px',
                            borderRadius: '16px',
                            background: statusBg,
                            color: statusColor,
                            border: `1px solid ${statusBorder}`,
                            boxShadow: statusShadow,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            transition: 'all 0.3s ease'
                        }}>
                            <span>{statusIcon}</span>
                            {statusText}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // 排阵阶段复用同一待选队员卡片，避免客队选队后入口随分队页面消失。
    const renderPendingMemberCard = () => getPendingMembers().length > 0 ? (
        <Card className="premium-lineup-card" title={renderPendingTitle()}>
            <Grid columns={3} gap={8}>
                {getUserRoleInfo(null, 3, 1)}
            </Grid>
        </Card>
    ) : null;

    if (pendingOnly) return renderPendingMemberCard();

    return (<div>
        {captainWorkflow.stage === CAPTAIN_WORKFLOW_STAGE.TEAM_NAMING && (
            <div className="ready-team-naming-card">
                <div className="ready-team-naming-heading">给两队取名</div>
                <div className="ready-team-naming-subtitle">管理员之后可修改队名</div>
                {canNameTeams ? (
                    <>
                        <div className="ready-team-naming-fields">
                            {namingTeams.map(team => (
                                <label
                                    key={team.key}
                                    className="ready-team-naming-field"
                                    style={{ '--naming-team-color': team.color }}
                                >
                                    <span className="ready-team-naming-team">
                                        <i aria-hidden="true" />
                                        {team.captainName ? `${team.captainName.charAt(0)}队` : team.fallback}
                                    </span>
                                    <Input
                                        value={teamNameDraft[team.key]}
                                        maxLength={20}
                                        placeholder="输入队名"
                                        onChange={value => setTeamNameDraft(current => ({ ...current, [team.key]: value }))}
                                    />
                                </label>
                            ))}
                        </div>
                        <button
                            className="premium-btn-base premium-btn-neon-green ready-primary-action"
                            type="button"
                            disabled={joinButtonLoading}
                            onClick={saveTeamNames}
                        >保存队名</button>
                    </>
                ) : (
                    <div className="ready-team-naming-waiting">
                        等待主队队长{greenCaptain?.name ? ` ${greenCaptain.name} ` : ''}或管理员填写两队名称
                    </div>
                )}
            </div>
        )}
        {/* 普通比赛保留管理员确认；内讧赛命名后直接进入主队调人。 */}
        {Number(gameDetail?.gameType) !== 3 && memberInfo?.admin === 1 && captainWorkflow.stage === CAPTAIN_WORKFLOW_STAGE.CAPTAIN_ASSIGNMENT &&
            <div style={{ padding: '0 12px', marginTop: '10px' }}>
                <button
                    className="premium-btn-base premium-btn-neon-cyan premium-btn-compact ready-primary-action"
                    style={{ width: '100%' }}
                    disabled={joinButtonLoading}
                    onClick={() => {
                        Dialog.confirm({
                            title: (
                                <div className="premium-dialog-header">
                                    <span className="premium-dialog-title-icon">🛡️</span>
                                    <span className="premium-dialog-title-text">管理员确认</span>
                                </div>
                            ),
                            content: (
                                <div className="premium-dialog-container">
                                    <div className="premium-dialog-section-title" style={{ textAlign: 'center', marginBottom: 12 }}>
                                        是否确认当前分队信息？
                                    </div>
                                    <div className="premium-tip-banner">
                                        <i className="premium-tip-icon">ℹ️</i>
                                        <span className="premium-tip-text">队名已确认，接下来由主队队长调换队员</span>
                                    </div>
                                    <div className="premium-confirm-details" style={{ fontSize: '13px', color: 'rgba(255,255,255,0.6)', textAlign: 'center' }}>
                                        不可回退到当前状态，请仔细检查。
                                    </div>
                                </div>
                            ),
                            onConfirm: () => {
                                setJoinButtonLoading(true)
                                const formData = new FormData();
                                formData.append('gameId', gameDetail.id)
                                formData.append("type", 1)
                                httpClient.post(API_ROUTES.game_adminConfirm, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                })
                                    .then(function (response) {
                                        const result = response.data
                                        if (result.code === 200) {
                                            Toast.show({
                                                icon: 'success',
                                                content: "确认成功！"
                                            })
                                            getGameDetail()
                                            getUserListInfo()
                                        } else {
                                            console.log(result)
                                            Toast.show({
                                                icon: 'fail',
                                                content: result.msg
                                            })
                                        }

                                    })
                                    .catch(function (error) {
                                        Toast.show({
                                            icon: 'fail',
                                            content: "系统错误！请联系管理员",
                                        })
                                    })
                                    .finally(() => {
                                        setJoinButtonLoading(false)
                                    });
                            }
                        })
                    }}
                >
                    <span className="premium-btn-icon">🛡️</span> 管理员确认
                </button>
            </div>
        }

        {captainWorkflow.stage === CAPTAIN_WORKFLOW_STAGE.GREEN_ADJUSTMENT && (memberInfo?.id === gameDetail?.greenCaptain?.id || memberInfo?.admin === 1)
            ?
            <div style={{ padding: '0 12px', marginTop: '10px' }}>
                <button
                    className="premium-btn-base premium-btn-neon-green premium-btn-compact ready-primary-action"
                    style={{ width: '100%' }}
                    disabled={joinButtonLoading}
                    onClick={() => {
                        Dialog.confirm({
                            title: (
                                <div className="premium-dialog-header">
                                    <span className="premium-dialog-title-icon">📋</span>
                                    <span className="premium-dialog-title-text">确认队员分配</span>
                                </div>
                            ),
                            content: (
                                <div className="premium-dialog-container">
                                    <div className="premium-dialog-section-title" style={{ textAlign: 'center', marginBottom: 12 }}>
                                        是否确认当前分队信息？
                                    </div>
                                    <div className="premium-tip-banner">
                                        <i className="premium-tip-icon">ℹ️</i>
                                        <span className="premium-tip-text">确认后由客队队长选择队伍，双方再安排首发阵容</span>
                                    </div>
                                    <div className="premium-confirm-details" style={{ fontSize: '13px', color: '#64748b', textAlign: 'center' }}>
                                        不可回退到当前状态，请确认无误。
                                    </div>
                                </div>
                            ),
                            onConfirm: () => {
                                setJoinButtonLoading(true)
                                const formData = new FormData();
                                formData.append('gameId', gameDetail.id)
                                formData.append("type", 2)
                                httpClient.post(API_ROUTES.game_adminConfirm, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                })
                                    .then(function (response) {
                                        const result = response.data
                                        if (result.code === 200) {
                                            Toast.show({
                                                icon: 'success',
                                                content: "确认成功！"
                                            })
                                            getGameDetail()
                                            getUserListInfo()
                                        } else {
                                            Toast.show({
                                                icon: 'fail',
                                                content: result.msg
                                            })
                                        }

                                    })
                                    .catch(function (error) {
                                        Toast.show({
                                            icon: 'fail',
                                            content: "系统错误！请联系管理员",
                                        })
                                    })
                                    .finally(() => {
                                        setJoinButtonLoading(false)
                                    });
                            }
                        })
                    }}>
                    {/* 当前仅确认分队结果，首发阵容由双方队长在下一阶段分别安排。 */}
                    <span className="premium-btn-icon">📋</span> 确认队员分配
                </button>
            </div>
            : null
        }

        {captainWorkflow.stage === CAPTAIN_WORKFLOW_STAGE.RED_SELECTION && (memberInfo?.id === gameDetail?.redCaptain?.id || memberInfo?.admin === 1)
            ?
            <Grid columns={2} gap={10} style={{ padding: '0 12px', marginTop: '10px' }}>
                <Grid.Item>
                    <button
                        className="premium-btn-base premium-btn-neon-cyan premium-btn-compact"
                        style={{ width: '100%' }}
                        disabled={joinButtonLoading}
                        onClick={() => {
                            const notAllocationMembers = memberListInfo?.filter(item => item.gameTeam === null && item.gameRole === 0)
                            if (notAllocationMembers.length > 0) {
                                Toast.show({
                                    icon: 'fail',
                                    content: "请让所有球员选择队伍！"
                                })
                            } else {
                                Dialog.confirm({
                                    title: (
                                        <div className="premium-dialog-header">
                                            <span className="premium-dialog-title-icon">🛡️</span>
                                            <span className="premium-dialog-title-text">选队确认</span>
                                        </div>
                                    ),
                                    content: (
                                        <div className="premium-dialog-container">
                                            <div className="premium-dialog-section-title" style={{ textAlign: 'center', marginBottom: 12 }}>
                                                是否确认选择 <span style={{ color: '#60a5fa' }}>A队</span>？
                                            </div>
                                            <div className="premium-confirm-details" style={{ fontSize: '13px', color: '#64748b', textAlign: 'center' }}>
                                                确认之后无法回退到当前状态。
                                            </div>
                                        </div>
                                    ),
                                    closeOnMaskClick: true,
                                    onConfirm: () => {
                                        setJoinButtonLoading(true)
                                        const formData = new FormData();
                                        formData.append('gameId', gameDetail.id)
                                        formData.append("type", 4)
                                        httpClient.post(API_ROUTES.game_adminConfirm, formData, {
                                            headers: {
                                                'Content-Type': 'multipart/form-data'
                                            }
                                        })
                                            .then(function (response) {
                                                const result = response.data
                                                if (result.code === 200) {
                                                    Toast.show({
                                                        icon: 'success',
                                                        content: "确认成功！"
                                                    })
                                                    getGameDetail()
                                                    getUserListInfo()
                                                } else {
                                                    Toast.show({
                                                        icon: 'fail',
                                                        content: result.msg
                                                    })
                                                }

                                            })
                                            .catch(function (error) {
                                                Toast.show({
                                                    icon: 'fail',
                                                    content: "系统错误！请联系管理员",
                                                })
                                            })
                                            .finally(() => {
                                                setJoinButtonLoading(false)
                                            });

                                    }
                                })
                            }
                        }}>
                        <span className="premium-btn-icon">🛡️</span> 选择A队
                    </button>
                </Grid.Item>
                <Grid.Item>
                    <button
                        className="premium-btn-base premium-btn-neon-cyan premium-btn-compact"
                        style={{ width: '100%' }}
                        disabled={joinButtonLoading}
                        onClick={() => {
                            const notAllocationMembers = memberListInfo?.filter(item => item.gameTeam === null && item.gameRole === 0)
                            if (notAllocationMembers.length > 0) {
                                Toast.show({
                                    icon: 'fail',
                                    content: "请让所有球员选择队伍！"
                                })
                            } else {
                                Dialog.confirm({
                                    title: (
                                        <div className="premium-dialog-header">
                                            <span className="premium-dialog-title-icon">🚩</span>
                                            <span className="premium-dialog-title-text">选队确认</span>
                                        </div>
                                    ),
                                    content: (
                                        <div className="premium-dialog-container">
                                            <div className="premium-dialog-section-title" style={{ textAlign: 'center', marginBottom: 12 }}>
                                                是否确认选择 <span style={{ color: '#60a5fa' }}>B队</span>？
                                            </div>
                                            <div className="premium-confirm-details" style={{ fontSize: '13px', color: '#64748b', textAlign: 'center' }}>
                                                确认之后无法回退到当前状态。
                                            </div>
                                        </div>
                                    ),
                                    closeOnMaskClick: true,
                                    onConfirm: () => {
                                        setJoinButtonLoading(true)
                                        const formData = new FormData();
                                        formData.append('gameId', gameDetail.id)
                                        formData.append("type", 3)
                                        httpClient.post(API_ROUTES.game_adminConfirm, formData, {
                                            headers: {
                                                'Content-Type': 'multipart/form-data'
                                            }
                                        })
                                            .then(function (response) {
                                                const result = response.data
                                                if (result.code === 200) {
                                                    Toast.show({
                                                        icon: 'success',
                                                        content: "确认成功！"
                                                    })
                                                    getGameDetail()
                                                    getUserListInfo()
                                                } else {
                                                    Toast.show({
                                                        icon: 'fail',
                                                        content: result.msg
                                                    })
                                                }

                                            })
                                            .catch(function (error) {
                                                Toast.show({
                                                    icon: 'fail',
                                                    content: "系统错误！请联系管理员",
                                                })
                                            })
                                            .finally(() => {
                                                setJoinButtonLoading(false)
                                            });

                                    }
                                })
                            }
                        }}>
                        <span className="premium-btn-icon">🛡️</span> 选择B队
                    </button>
                </Grid.Item>
            </Grid>
            : null
        }

        {memberListInfo.filter(item => item.gameTeam === null && item.gameRole === 0 && item.id === memberInfo.id).length > 0 &&
            <Grid columns={2} gap={10} style={{ padding: '0 12px', marginTop: '10px' }}>
                <Grid.Item>
                    <button
                        className="premium-btn-base premium-btn-neon-green premium-btn-compact"
                        style={{ width: '100%' }}
                        disabled={joinButtonLoading}
                        onClick={() => {
                            Dialog.confirm({
                                title: (
                                    <div className="premium-dialog-header">
                                        <span className="premium-dialog-title-icon">🏃</span>
                                        <span className="premium-dialog-title-text">加入 {getTeamName(1)}</span>
                                    </div>
                                ),
                                content: (
                                    <div className="premium-dialog-container">
                                        <div className="premium-dialog-section-title" style={{ textAlign: 'center', marginBottom: 12 }}>
                                            确认加入 <span style={{ color: '#10b981' }}>{getTeamName(1)}</span> 阵容？
                                        </div>
                                        <div className="premium-confirm-details" style={{ fontSize: '13px', color: '#64748b', textAlign: 'center' }}>
                                            确认之后无法回退到当前状态。
                                        </div>
                                    </div>
                                ),
                                closeOnMaskClick: true,
                                onConfirm: () => {
                                    setJoinButtonLoading(true)
                                    const data = {
                                        team: 1,
                                        gameId: gameDetail.id,
                                        userId: memberInfo.id
                                    };
                                    httpClient.post(API_ROUTES.game_changePosition, data)
                                        .then((response) => {
                                            if (response.data?.code !== 200) {
                                                Toast.show({ icon: 'fail', content: response.data?.msg || '修改失败' });
                                                return;
                                            }
                                            Toast.show({
                                                icon: 'success',
                                                content: '修改成功',
                                                duration: 2
                                            })
                                            getUserListInfo()
                                        })
                                        .catch(() => {
                                            Toast.show({
                                                icon: 'fail',
                                                content: '修改失败',
                                            })
                                        })
                                        .finally(() => {
                                            setJoinButtonLoading(false)
                                        });
                                }
                            })
                        }}>
                        <span className="premium-btn-icon">🏃</span> 加入{getTeamName(1)}
                    </button>
                </Grid.Item>
                <Grid.Item>
                    <button
                        className="premium-btn-base premium-btn-neon-red premium-btn-compact"
                        style={{ width: '100%' }}
                        disabled={joinButtonLoading}
                        onClick={() => {
                            Dialog.confirm({
                                title: (
                                    <div className="premium-dialog-header">
                                        <span className="premium-dialog-title-icon">🏃</span>
                                        <span className="premium-dialog-title-text">加入 {getTeamName(2)}</span>
                                    </div>
                                ),
                                content: (
                                    <div className="premium-dialog-container">
                                        <div className="premium-dialog-section-title" style={{ textAlign: 'center', marginBottom: 12 }}>
                                            确认加入 <span style={{ color: '#ef4444' }}>{getTeamName(2)}</span> 阵容？
                                        </div>
                                        <div className="premium-confirm-details" style={{ fontSize: '13px', color: '#64748b', textAlign: 'center' }}>
                                            确认之后无法回退到当前状态。
                                        </div>
                                    </div>
                                ),
                                closeOnMaskClick: true,
                                onConfirm: () => {
                                    setJoinButtonLoading(true)
                                    const data = {
                                        team: 2,
                                        gameId: gameDetail.id,
                                        userId: memberInfo.id
                                    };
                                    httpClient.post(API_ROUTES.game_changePosition, data)
                                        .then((response) => {
                                            if (response.data?.code !== 200) {
                                                Toast.show({ icon: 'fail', content: response.data?.msg || '修改失败' });
                                                return;
                                            }
                                            Toast.show({
                                                icon: 'success',
                                                content: '修改成功',
                                                duration: 2
                                            })
                                            getUserListInfo()
                                        })
                                        .catch(() => {
                                            Toast.show({
                                                icon: 'fail',
                                                content: '修改失败',
                                            })
                                        })
                                        .finally(() => {
                                            setJoinButtonLoading(false)
                                        });
                                }
                            })
                        }}>
                        <span className="premium-btn-icon">🏃</span> 加入B队
                    </button>
                </Grid.Item>
            </Grid>
        }


        <div className="versus-captains-container">
            <div className="versus-captains-header">
                <div className="versus-captains-title">Commanders</div>
            </div>
            <div className="versus-captains-grid">
                {renderCaptainCard(greenCaptain, gameDetail.greenColor, getTeamName(1), false, gameDetail.greenCaptainConfirm)}

                <div className="versus-separator">
                    <span className="vs-icon-text">VS</span>
                </div>

                {renderCaptainCard(redCaptian, gameDetail.redColor, getTeamName(2), true, gameDetail.redCaptainConfirm)}
            </div>
        </div>
        <div className="team-lineup-wrapper team-lineup-wrapper--a">
            <div className="team-section-banner" style={{ '--banner-color': '#60a5fa' }}>
                <div className="team-section-banner-left">
                    <span className="team-section-banner-letter">A</span>
                    <div className="team-section-banner-info">
                        <span className="team-section-banner-name">{getTeamName(1)}</span>
                        <span className="team-section-banner-count">
                            {memberListInfo?.filter(i => i.gameTeam === 1).length} 人
                        </span>
                    </div>
                </div>
                <div className="team-section-banner-right">
                    {(memberInfo.admin === 1 || memberInfo.id === greenCaptain.id) &&
                        <button className="team-banner-action-btn" onClick={() => {
                            let chooseid = []
                            Dialog.confirm({
                                title: (
                                    <div className="premium-dialog-header">
                                        <span className="premium-dialog-title-icon">🤔</span>
                                        <span className="premium-dialog-title-text">移至待定</span>
                                    </div>
                                ),
                                content: (
                                    <div className="premium-dialog-container">
                                        <div className="premium-dialog-section-title">选择 {getTeamName(1)} 移出的人员</div>
                                        <Selector
                                            className="premium-selector-container"
                                            columns={3}
                                            options={
                                                memberListInfo?.filter(item => item.gameTeam === 1 && item.id !== redCaptian.id && item.id !== greenCaptain.id)?.map(item => ({ label: item.name, value: item.id }))
                                            }
                                            multiple
                                            onChange={(arr, _) => chooseid = arr}
                                        />
                                    </div>
                                ),
                                onConfirm: () => {
                                    if (!chooseid?.length) { Toast.show({ icon: 'fail', content: '请选择人员！' }); return; }
                                    const formData = new FormData();
                                    formData.append('gameId', gameDetail.id)
                                    formData.append('memberId', chooseid?.join(','))
                                    axios.post(API_ROUTES.game_update_determined, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                                        .then(res => { if (res.data.code === 200) { Toast.show({ icon: 'success', content: '修改成功！' }); getGameDetail(); getUserListInfo(); } else { Toast.show({ icon: 'fail', content: res.data.msg }); } })
                                        .catch(() => Toast.show({ icon: 'fail', content: '系统错误！请联系管理员' }))
                                }
                            });
                        }}>
                            <span>+</span> 待定
                        </button>
                    }
                </div>
            </div>
            <div className="team-lineup-players">
                <Grid columns={3} gap={8}>
                    {getUserRoleInfo(7, 1, 0)}
                    {getUserRoleInfo(6, 1, 0)}
                    {getUserRoleInfo(5, 1, 0)}
                    {getUserRoleInfo(4, 1, 0)}
                    {getUserRoleInfo(3, 1, 0)}
                    {getUserRoleInfo(2, 1, 0)}
                    {getUserRoleInfo(1, 1, 0)}
                </Grid>
            </div>
        </div>

        <AutoCenter style={{ fontSize: '24px', margin: '10px', fontWeight: '800', fontStyle: 'italic' }}>
            - PK -
        </AutoCenter>

        <div className="team-lineup-wrapper team-lineup-wrapper--b">
            <div className="team-section-banner" style={{ '--banner-color': '#60a5fa' }}>
                <div className="team-section-banner-left">
                    <span className="team-section-banner-letter">B</span>
                    <div className="team-section-banner-info">
                        <span className="team-section-banner-name">{getTeamName(2)}</span>
                        <span className="team-section-banner-count">
                            {memberListInfo?.filter(i => i.gameTeam === 2).length} 人
                        </span>
                    </div>
                </div>
                <div className="team-section-banner-right">
                    {(memberInfo.admin === 1 || memberInfo.id === redCaptian?.id) &&
                        <button className="team-banner-action-btn" onClick={() => {
                            let chooseid = []
                            Dialog.confirm({
                                title: (
                                    <div className="premium-dialog-header">
                                        <span className="premium-dialog-title-icon">🤔</span>
                                        <span className="premium-dialog-title-text">移至待定</span>
                                    </div>
                                ),
                                content: (
                                    <div className="premium-dialog-container">
                                        <div className="premium-dialog-section-title">选择 {getTeamName(2)} 移出的人员</div>
                                        <Selector
                                            className="premium-selector-container"
                                            columns={3}
                                            options={
                                                memberListInfo?.filter(item => item.gameTeam === 2 && item.id !== redCaptian.id && item.id !== greenCaptain.id)?.map(item => ({ label: item.name, value: item.id }))
                                            }
                                            multiple
                                            onChange={(arr, _) => chooseid = arr}
                                        />
                                    </div>
                                ),
                                onConfirm: () => {
                                    if (!chooseid?.length) { Toast.show({ icon: 'fail', content: '请选择人员！' }); return; }
                                    const formData = new FormData();
                                    formData.append('gameId', gameDetail.id)
                                    formData.append('memberId', chooseid?.join(','))
                                    axios.post(API_ROUTES.game_update_determined, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                                        .then(res => { if (res.data.code === 200) { Toast.show({ icon: 'success', content: '修改成功！' }); getGameDetail(); getUserListInfo(); } else { Toast.show({ icon: 'fail', content: res.data.msg }); } })
                                        .catch(() => Toast.show({ icon: 'fail', content: '系统错误！请联系管理员' }))
                                }
                            });
                        }}>
                            <span>+</span> 待定
                        </button>
                    }
                </div>
            </div>
            <div className="team-lineup-players">
                <Grid columns={3} gap={8}>
                    {getUserRoleInfo(7, 2, 0)}
                    {getUserRoleInfo(6, 2, 0)}
                    {getUserRoleInfo(5, 2, 0)}
                    {getUserRoleInfo(4, 2, 0)}
                    {getUserRoleInfo(3, 2, 0)}
                    {getUserRoleInfo(2, 2, 0)}
                    {getUserRoleInfo(1, 2, 0)}
                </Grid>
            </div>
        </div>
        {renderPendingMemberCard()}

    </div>)


}


export default GameReadyStepOne;
